module.exports = "/_next/static/images/9day-b5e883cba813e2dc4af1fa3e360b9d52.png";